export const TRANSFER_CONFIG = 'TRANSFER_CONFIG';
// export const TRANSFER_CONFIG_LOADING = 'TRANSFER_CONFIG_LOADING';
export const SKETCH_CONFIGS = 'SKETCH_CONFIGS';
export const TRANSFER_SUPPORTED_CHAINS_COUNT = 'TRANSFER_SUPPORTED_CHAINS_COUNT';
